<template>
    <div class="modal"
         :class="{ 'is-active': isShown }"
    >
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ trans.delete_modal_title }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="closeModal"
                ></button>
            </header>

            <section class="modal-card-body">
                {{ trans.delete_modal_text }}
            </section>

            <footer class="modal-card-foot">
                <button
                    class="button is-danger"
                    @click="confirmDeletion"
                >
                    {{ trans.delete_comment }}
                </button>
                <button
                    class="button is-outlined"
                    @click="closeModal"
                >
                    {{ trans.cancel_comment_button }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "CommentDeletionConfirmationModal",
    computed: {
        ...mapState('comment', {
            isShown: 'commentDeletionConfirmationModalIsShown',
        }),
        ...mapState('comment', [
            'trans',
            'commentHash',
        ]),
    },
    methods: {
        ...mapActions('comment', [
            'deleteComment',
            'showCommentErrorDocumentDeletedModal',
        ]),
        ...mapActions('comment', {
            closeModal: 'hideDeletionConfirmationModal',
        }),
        confirmDeletion() {
            this.deleteComment(this.commentHash)
                .catch(error => {
                    if (error.response.status === 404) {
                        this.showCommentErrorDocumentDeletedModal(false);
                    }
                });

            this.closeModal();
        },
    },
}
</script>

<style lang="css" scoped>
    .bulma .modal {
        width: 100%;
    }
</style>
